module.exports = __webpack_public_path__ + "img/2.9800090b.png";